module.exports = __webpack_public_path__ + "img/equipo.656ddd3e.svg";